enum FishingEquipment {
  YES = 'hankittu',
  NO = 'ei_hankittu',
}

export default FishingEquipment;
